import React, { useEffect, useState } from 'react';
import CustomColumnChart from '../../../shared/charts/custom-column-chart/CustomColumnChart';
import StatisticsItemList from '../statistics-item-list/StatisticsItemList';
import CustomLineChart from '../../../shared/charts/custom-line-chart/CustomLineChart';
import CustomDualAxesChart from '../../../shared/charts/custom-dual-axes-chart/CustomDualAxesChart';
import StatisticsCard from '../statistics-card/StatisticsCard';
import moment from 'moment';
import { statisticsDataKeys } from '../../analytics/Analytics';

function Wellness(props) {
  const {
    allStatisticsData,
    selectedSpa = { value: [] },
    showAllForReport = false,
    currency,
  } = props;
  const [orderTrend, setOrderTrend] = useState([]);
  const [avgItemsOnOrder, setAvgItemsOnOrder] = useState([]);
  const [mostOrderedItems, setMostOrderedItems] = useState([]);
  const [unpopularItems, setUnpopularItems] = useState([]);
  const [busiestDayOfWeek, setBusiestDayOfWeek] = useState([]);
  const [busiestTimeOfDay, setBusiestTimeOfDay] = useState([]);
  const [popularTreatments, setPopularTreatments] = useState([]);

  useEffect(() => {
    const statisticValues = {
      busiestDayOfWeek: setBusiestDayOfWeek,
      busiestTimeOfDay: setBusiestTimeOfDay,
      mostOrderedItems: setMostOrderedItems,
      orderTrend: setOrderTrend,
      unpopularItems: setUnpopularItems,
      avgItemsOnOrder: setAvgItemsOnOrder,
      popularTreatments: setPopularTreatments,
    };

    for (const key of Object.keys(statisticValues)) {
      if (allStatisticsData && allStatisticsData[key]) {
        statisticValues[key](allStatisticsData[key]);
      }
    }
  }, [allStatisticsData]);

  return selectedSpa?.value?.length > 0 ? (
    <div className='col-12 d-flex flex-wrap gap-2 wellness-container'>
      {/* <div className="col-auto col-sm-12 col-md-auto col-lg-auto">
        <StatisticsCard
          currencyCode={allStatisticsData?.currencyCode}
          data={[
            { name: "Treatments", value: allStatisticsData?.totalOrderCount },
            {
              name: "Transaction",
              value: allStatisticsData?.totalAmount,
            },
            {
              name: "Revenue",
              value: allStatisticsData?.totalUpsellAmount,
            },
          ]}
        />
      </div> */}
      {orderTrend?.length > 0 && (
        <div className='col-auto col-sm-12 col-md col-lg box-shadow custom-card mw-100'>
          <div className='h-100 w-100 mw-100 mh-100'>
            <CustomDualAxesChart
              title={'Appointment Trend'}
              xAxis={statisticsDataKeys?.date}
              yAxis1={statisticsDataKeys?.treatmentAmount}
              yAxis2={statisticsDataKeys?.treatmentCount}
              data={orderTrend?.map((order, index) => {
                return {
                  Date: moment(new Date(order?.date)).format(statisticsDataKeys?.dateFormat),
                  [statisticsDataKeys?.treatmentAmount]: order?.orderAmount,
                  [statisticsDataKeys?.treatmentCount]: order?.orderCount,
                };
              })}
              currency={currency}
            />
          </div>
        </div>
      )}
      {avgItemsOnOrder?.length > 0 && (
        <div className='col-12 box-shadow custom-card mw-100'>
          <div className='px-2 pt-2 h-100 w-100 mw-100 mh-100'>
            <CustomLineChart
              title={'Appointments'}
              xAxis={statisticsDataKeys?.date}
              yAxis={statisticsDataKeys?.avgTreatmentPerAppointment}
              data={avgItemsOnOrder?.map((order, index) => {
                return {
                  Date: moment(new Date(order?.date)).format(statisticsDataKeys?.dateFormat),
                  [statisticsDataKeys?.avgTreatmentPerAppointment]: order?.avgOrderItemsCount,
                };
              })}
              includeCard={true}
              additionalData={[
                {
                  name: statisticsDataKeys?.avgTreatmentPerAppointment,
                  value: allStatisticsData?.avgItemsPerOrder,
                },
                {
                  name: statisticsDataKeys?.medianTreatmentPerAppointment,
                  value: allStatisticsData?.median || 0,
                },
              ]}
            />
          </div>
        </div>
      )}
      <div className='col-12 box-shadow custom-card mw-100 mh-100 d-flex flex-wrap gap-2 p-2'>
        <div className='d-flex col-12 col-md-12 col-lg-12 flex-wrap px-2 mw-100'>
          {popularTreatments?.length > 0 && (
            <div className='col-12 col-md-6 col-lg-4'>
              <div className='px-2'>
                <StatisticsItemList
                  title='Most Requested Treatments'
                  key={1}
                  itemListHeight={true}
                  numberField={statisticsDataKeys?.treatmentCount}
                  columnNames={[statisticsDataKeys?.name, statisticsDataKeys?.treatmentCount]}
                  items={popularTreatments?.map((treatment) => {
                    return {
                      [statisticsDataKeys?.name]: treatment?.name || '---',
                      [statisticsDataKeys?.treatmentCount]: treatment?.bookings,
                    };
                  })}
                  showAllForReport={showAllForReport}
                  showErrorsList={true}
                />
              </div>
            </div>
          )}
          {popularTreatments?.length > 0 && (
            <div className='col-12 col-md-6 col-lg-4'>
              <div className='px-2'>
                <StatisticsItemList
                  title='Unpopular Treatments'
                  key={2}
                  itemListHeight={true}
                  numberField={statisticsDataKeys?.daysSinceLastTreatment}
                  columnNames={[
                    statisticsDataKeys?.name,
                    statisticsDataKeys?.daysSinceLastTreatment,
                  ]}
                  items={popularTreatments?.map((treatment) => {
                    return {
                      [statisticsDataKeys?.name]: treatment?.name || '---',
                      [statisticsDataKeys?.daysSinceLastTreatment]: treatment?.daysSinceLastOrdered,
                    };
                  })}
                  showAllForReport={showAllForReport}
                  showErrorsList={true}
                />
              </div>
            </div>
          )}
          <div className='col-12 col-md-12 col-lg-4 d-flex flex-column gap-2'>
            {busiestDayOfWeek?.length > 0 && (
              <div className='col-12 h-50'>
                <CustomColumnChart
                  title={statisticsDataKeys?.busiestDayOfTheWeek}
                  xAxis='Day'
                  yAxis={statisticsDataKeys?.treatmentCount}
                  data={busiestDayOfWeek?.map((dayData, index) => {
                    return {
                      Day: dayData?.day,
                      [statisticsDataKeys?.treatmentCount]: dayData?.orderCount,
                    };
                  })}
                />
              </div>
            )}
            {busiestTimeOfDay?.length > 0 && (
              <div className='col-12 h-50'>
                <CustomColumnChart
                  title={statisticsDataKeys?.busiestTimeOfTheDay}
                  xAxis='Time'
                  yAxis={statisticsDataKeys?.treatmentCount}
                  data={busiestTimeOfDay?.map((timeData, index) => {
                    return {
                      Time: timeData?.time,
                      [statisticsDataKeys?.treatmentCount]: timeData?.orderCount,
                    };
                  })}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  ) : (
    <div className='p-2 pt-4 h-100 w-100 d-flex align-items-center justify-content-center'>
      <h5>Please select spa to generate reports.</h5>
    </div>
  );
}

export default Wellness;
